import type { UserRole } from "@/types";

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? "Orion";

// ─── Roles ────────────────────────────────────────────────────────────────────
export const ROLES = {
  STUDENT:    "Student"    as UserRole,
  TEACHER:    "Teacher"    as UserRole,
  SUPER_ADMIN: "SuperAdmin" as UserRole,
};

// ─── Route paths ─────────────────────────────────────────────────────────────
export const ROUTES = {
  // Auth
  LOGIN:    "/login",
  REGISTER: "/register",
  FORGOT:   "/forgot-password",
  RESET:    "/reset-password",

  // Core app
  HOME:        "/",
  DASHBOARD:   "/dashboard",
  PROFILE:     "/profile",

  // Content
  CONTENT:        "/content",
  CONTENT_DETAIL: "/content/:id",

  // Playground & sub-sections
  PLAYGROUND:          "/playground",
  PLAYGROUND_OOP:      "/playground/oop",
  PLAYGROUND_SOLID:    "/playground/solid",
  PLAYGROUND_PATTERNS: "/playground/design-patterns",

  // SDLC tools
  SRS: "/sdlc/srs",
  UML: "/sdlc/uml",
  WBS: "/sdlc/wbs",

  // Extras
  CHAT: "/chat",

  // Admin
  ADMIN:          "/admin",
  ADMIN_USERS:    "/admin/users",
  ADMIN_FEATURES: "/admin/features",
  ADMIN_CONTENT:  "/admin/content",
} as const;

// ─── Query keys factory ───────────────────────────────────────────────────────
export const QK = {
  auth:     { me: ["auth", "me"] },
  users:    {
    all:    (p?: object)  => ["users", p ?? {}],
    detail: (id: string)  => ["users", id],
  },
  content:  {
    all:      (p?: object) => ["content", p ?? {}],
    detail:   (id: string) => ["content", id],
    progress: (id: string) => ["content", id, "progress"],
  },
  playground: {
    snippets: ["playground", "snippets"],
  },
  srs:  { all: ["srs"], detail: (id: string) => ["srs", id] },
  uml:  { all: ["uml"], detail: (id: string) => ["uml", id] },
  wbs:  { all: ["wbs"], detail: (id: string) => ["wbs", id] },
  admin: {
    stats:      ["admin", "stats"],
    activities: (page: number, size: number) => ["admin", "activities", page, size],
    users:      ["admin", "users"],
    features:   ["admin", "features"],
  },
} as const;
